import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shippingSectionTitle: {
    defaultMessage: 'Shipping',
    description: 'ordersHeader.shipping',
    id: 'hXzOtR',
  },
  preset: {
    description:
      'Label for the "Preset" dropdown, used to apply and manage presets. A "Preset" is a user built shipment configuration (Service, dimensions, weight, etc.) that can be applied to a shipment.',
    defaultMessage: 'Preset',
    id: 'TfN1ze',
  },
});
